module.exports = __webpack_public_path__ + "img/thumb_19.08738ace.jpg";